import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { formatRuDateTimeString } from '../../../../../helpers/date-time';
import { TaskType } from '../../../../../store/api/tasks-api';
import { TasksInfo } from '../tasks-info/tasks-info';
import { useTaskListUtils } from '../use-task-list-utils';
import s from './task-card-item.module.css';

interface Props {
  item: TaskType;
}

export const TaskCardItem: FC<Props> = (props) => {
  const { item } = props;

  const {
    getEmployee,
    getStatusLabel,
    getStatusVariant,
    isStatusEditable,
    isDeletedEmployee,
    t,
    getLocale,
  } = useTaskListUtils();

  const employee = getEmployee(item);
  const isRequiresExecutor = isStatusEditable(item.status) && isDeletedEmployee(employee);

  const topItems = [
    { title: 'Название', subtitle: getLocale(item.title) },
    { title: 'Филиал', subtitle: getLocale(item.place_name) },
    { title: 'Ответственный', subtitle: employee?.value },
  ];

  const bottomItems = [
    { title: 'Создано', subtitle: formatRuDateTimeString(item.created_at) },
    { title: 'Выполнено', subtitle: formatRuDateTimeString(item.resolved_at) },
  ];

  const renderItems = (items: { title: string; subtitle: ReactNode }[]) => (
    <ul className={s.list}>
      {items.map(({ title, subtitle }, index) => (
        <li key={index}>
          <div className={t(s.title)}>{title}</div>
          <div className={s.subtitle}>{subtitle}</div>
        </li>
      ))}
    </ul>
  );

  return (
    <li className={s.feature} id={`card-${item.id}`}>
      {renderItems(topItems)}

      <div className={s.main}>
        <div>
          <span className={s.title} style={{ marginRight: 38 }}>
            {t('Статус')}
          </span>
          <span className={cn(s.subtitle, s[getStatusVariant(item.status, isRequiresExecutor)])}>
            {getStatusLabel(item.status, isRequiresExecutor)}
          </span>
        </div>
        <div className={s.qr}>QR {getLocale(item.qr?.value)}</div>
        <TasksInfo task={item} />
      </div>

      {renderItems(bottomItems)}
    </li>
  );
};
